import { createGlobalStyle } from 'styled-components';
import { getIssuer } from '~/helpers/getIssuer';
import { JVCEF } from '~/config/constants';

const issuer = getIssuer();
const fontName = issuer === JVCEF ? 'Futura' : 'Montserrat';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "Futura";
    src: url("fonts/FuturaStdBook.otf") format('opentype');
  }
  @font-face {
    font-family: "FuturaBold";
    src: url("fonts/FuturaBoldBT.ttf") format('truetype');
  }
  @font-face {
    font-family: "FuturaMedium";
    src: url("fonts/FuturaMediumBT.ttf") format('truetype');
  }

  *:before, *:after {
    box-sizing: inherit;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    background: ${({ theme }) => theme.colors.institucional};
    font-size: 15px;
    font-family: ${fontName}, sans-serif;
    line-height: 1.5;
  }

  label {
    display: inline-block;
    margin-bottom: .5rem;
  }

  p {
    margin: 0;
  }
`;

export default GlobalStyle;
